<template>
<el-scrollbar :ref="scrollRef">
  <el-tree
    class="tree-w-stroke obj-tree"
    v-loading="rootLoading"
    :ref="treeRef"
    lazy
    :default-expanded-keys="[1]"
    :load="loadData"
    :props="defaultProps"
    :node-key="defaultProps.treeKey"
    :expand-on-click-node="false"
    highlight-current
    @node-click="clickNode"
  >
    <span class="el-tree-node__label" slot-scope="{ node, data }">
      <!-- obj -->
      <el-tooltip v-if="isObjNode(data) && isRequireIPObjType(data)" class="item" effect="dark" :content="getIpTooltipContent(data)" placement="right">
        <span>
          <span v-if="!isEmpty(data.subType)" class="obj-icon">
            <i :class="getObjTypeIconClass(data)"></i>
          </span>
          <span :style="getNodeEventLevelStyle(data)"></span>
          <span>{{ data.label }}</span>
        </span>
      </el-tooltip>
      <span v-else-if="isObjNode(data)">
        <span v-if="!isEmpty(data.subType)" class="obj-icon">
          <i :class="getObjTypeIconClass(data)"></i>
        </span>
        <span :style="getNodeEventLevelStyle(data)"></span>
        <span>{{ data.label }}</span>
      </span>
      <!-- root, group -->
      <span v-else>
        <span :style="getNodeEventLevelStyle(data)"></span>
        <span class="group">{{ data.label }}</span>
      </span>
    </span>
  </el-tree>
</el-scrollbar>
</template>

<script>
import { isEmpty, assign } from 'lodash';
import RouterTree from '@/mixins/router/tree';
import { defaultProps, treeType } from '@/constants/tree';
import { isRequireIPObjType, getObjTypeIconClass, isObjNode, getIpTooltipContent, hasObjTypeIcon } from '@/utils/tree';
import { getValueAfterCheckEmpty } from '@/utils/string';
import TreeApi from '@/api/common/tree';
import MsgUtil from '@/utils/message';
import DynamicTreeMixin from '@/mixins/tree/dynamic-tree';
import DynamicTargetTreeMixin from './mixins/dynamic-tree';
import EventStatusMixin from './mixins/event-status';

export default {
  name: 'WPhysicalTree',
  mixins: [RouterTree, DynamicTreeMixin, DynamicTargetTreeMixin, EventStatusMixin],
  props: {
    treeTypes: {
      type: Array,
      default: null,
    },
    expandedGroupFlag: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      treeType: treeType.PHYSICAL,
      treeRef: `${treeType.PHYSICAL}Tree`,
      treeTypesInMenu: this.treeTypes,
      defaultProps,
      dynamicFlag: true,
      rootLoading: false,
    };
  },
  methods: {
    isEmpty,
    getValueAfterCheckEmpty,
    isObjNode,
    isRequireIPObjType,
    hasObjTypeIcon,
    getObjTypeIconClass,
    getIpTooltipContent,
    /**
     * 노드 클릭 이벤트 핸들러
     * @author Ju
     * @param  {[type]} nodeData [description]
     * @return {[type]}          [description]
     */
    clickNode(nodeData) {
      this.fixScroll = true;
      this.routeByTreeKey(this.concatTreeTypeAndTreeKey(nodeData[this.defaultProps.treeKey]));
    },
    /**
     * 트리 노드 데이터를 조회한다.
     * @author Ju
     * @param  {Object} node    부모 노드 객체
     * @param  {Object} resolve
     */
    loadData(node, resolve) {
      if (node.level === 0 && this.loading === true) {
        return;
      }
      const params = assign(this.getBaseParams(node), this.getRouterTreeParams(node));
      this.loading = true;
      if (node.level === 0) {
        this.rootLoading = true;
      }
      this.loading = true;
      TreeApi.getPhysicalTreeData(params)
        .then((response) => {
          if (response.data.success) {
            this.setChildren(resolve, response.data.children, params);
          } else {
            this.$message(MsgUtil.getResultMsgData(MsgUtil.action.VIEW, '물리 그룹 트리 정보', false));
          }
        })
        .catch((e) => {
          this.$message(MsgUtil.getResultMsgData(MsgUtil.action.VIEW, '물리 그룹 트리 정보', false));
          throw new Error(e);
        })
        .finally(() => {
          this.rootLoading = false;
          this.loading = false;
        });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/tree/TargetTree/DynamicPhysicalTree.vue